import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'backoffice-error-access-denied',
  templateUrl: './error-access-denied.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ErrorAccessDeniedComponent {}
